/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchAccountWithStatsResponseItem } from './search-account-with-stats-response-item';


export interface SearchAccountWithStatsResponseItemPagedList { 
    totalCount?: number;
    items?: Array<SearchAccountWithStatsResponseItem> | null;
}

